import InboundProduct from '@/components/dialogs/checker/pickup'

export default {
  components: {
    InboundProduct
  },
  methods: {
    onInfoClose() {
      // this.$router.push("/order-centric");
    }
  }
}